import React from 'react'
import { LoadingOverlay } from '../loading';
import useLink from './useLink';
import { useLocation } from 'react-router-dom';

const ForgotPassword = ({setScreen}) => {
    const location = useLocation()
    const { email, setEmail, handleLink, errorMessage, success, isLoading } = useLink();

    const submitLink = () => {
        const emailInput = document.getElementById('email');
        if (emailInput.validity.valid) {
            handleLink()
        } else {
            emailInput.reportValidity()
        }
    }

    return (
        <>
            {(isLoading) ?
                <LoadingOverlay />
            :
                ""
            }
                <div className="w-full">
                    <div className="space-y-4 md:space-y-6">
                        <h1 className={"leading-tight tracking-tight text-gray-900 " + (location.pathname === '/s%C3%A6lgbog' ? "text-base xl:text-lg font-medium" : "text-xl md:text-2xl font-bold")}>
                            Glemt adgangskode
                        </h1>
                        {(success) ?
                            <div className="text-center py-5 px-2 bg-emerald-300 bg-opacity-50">
                                <p>Vi har sendt en e-mail med instruktioner til:<br></br><span className="font-semibold">{email}</span></p>
                            </div>
                        :
                            <>
                                {(errorMessage !== '') ?
                                    <div className="text-center text-sm w-full py-4 px-2 bg-red-200">
                                        <p>{errorMessage}</p>
                                    </div>
                                :
                                    ""
                                }
                                <div className="space-y-4 md:space-y-6">
                                    <div>
                                        <label for="email" className="block mb-2 text-sm font-medium text-gray-900">Email</label>
                                        <input type="email" name="email" id="email" placeholder='Indtast din email' className="bg-gray-50 border border-gray-300 text-gray-900 block w-full p-2.5 outline-none text-sm sm:text-base" value={email} onChange={(e) => setEmail(e.target.value)} onKeyDown={(e) => e.key === 'Enter' ? submitLink() : ""} required />
                                    </div>
                                    <button type="submit" onClick={submitLink} className="focus:bg-pos-100 w-full text-white bg-gradient-to-r from-emerald-600 to-emerald-700 bg-pos-0 bg-size-200 hover:bg-pos-100 transition-all duration-150 ease-in-out outline-none font-medium text-sm px-5 py-2.5 text-center">Fortsæt</button>
                                    <p className="text-sm">
                                        Har du ikke en konto? <span className="font-medium hover:text-black transition-all duration-100 text-nowrap cursor-pointer" onClick={() => setScreen(2)}>Opret konto</span>
                                    </p>
                                </div>
                            </>}
                        {(success) ?
                            <div className="space-y-1">
                                <h2 className="font-medium">Har du ikke modtaget e-mailen?</h2>
                                <p className="text-sm">Det kan tage op til 5 minutter. Husk at tjekke din spammappe.</p>
                            </div>
                        :
                            ""}
                    </div>
                </div>
        </>
    )
}

export default ForgotPassword